(() => {
  const readyAttribute = 'data-interactive-popup-trigger-ready';

  if (document.documentElement.hasAttribute(readyAttribute)) return;
  document.documentElement.setAttribute(readyAttribute, '');

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-interactive-popup-open]');
    if (!trigger) return;

    const popup = document.querySelector('.interactive-popup-overlay');
    if (!popup) {
      const footerNewsletter = document.querySelector('.footer__block--newsletter');
      if (!footerNewsletter) return;

      event.preventDefault();

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const emailField = footerNewsletter.querySelector('[data-newsletter-field]');

      footerNewsletter.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'center',
      });

      window.setTimeout(() => {
        emailField?.focus({ preventScroll: true });
      }, prefersReducedMotion ? 0 : 600);

      return;
    }

    event.preventDefault();

    popup.querySelectorAll('.popup-step').forEach((step) => {
      step.classList.remove('is-active');
    });
    popup.querySelector('.step-1')?.classList.add('is-active');
    popup.querySelector('.popup-form')?.reset();
    popup.classList.add('is-visible');

    window.setTimeout(() => {
      popup.querySelector('.option-btn, .popup-close')?.focus();
    }, 0);
  }, { capture: true });
})();
